import { Formik, Form } from 'formik'
import cn from 'classnames'

import { Button } from '@components/Buttons'
import { AdvanceIcon } from '@components/icons/AdvanceIcon'
import { MultiSelectField } from '@components/forms/MultiSelectField'
import { SelectButtonField } from '@components/forms/SelectButtonField'
import { DateField } from '@components/forms/DateField'
import { TimeRangeEnum } from '@interfaces/TimeRangeEnum'
import { timeRangeOption } from '../SearchSaleAnalytics/withSearchSaleAnalytics'
import { ExportButton } from '../ExportButton'
import { SearchSaleAnalyticsProps } from '../SearchSaleAnalytics/interfaces'
import { SearchSaleAnalyticsType } from '../SearchSaleAnalytics/interfaces/SearchSaleAnalyticsType'
import { SearchEbookField } from '../SearchEbookField'

export function SearchEbookSaleAnalytics({
  initialValues,
  advanceSearch,
  bookType,
  categories,
  penNameOptions,
  queryParams,
  handleSubmit,
  handleAdvanceSearchChange,
}: SearchSaleAnalyticsProps) {
  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting, resetForm, setFieldValue, values }) => (
          <Form>
            <div className='grid gap-y-[20px] '>
              <div
                className={cn(
                  'flex desktop-tablet:space-x-[20px] mobile:gap-y-[20px] mobile:grid mobile:grid-cols-[1fr_88px] mobile:gap-x-[20px]'
                )}
              >
                <SearchEbookField
                  name='ebookId'
                  placeholder='ค้นหางานเขียน'
                  inputClassName='font-light bg-gray-1 text-secondary rounded-[20px] border-none'
                  className='flex-1'
                />
                <ExportButton queryParams={queryParams} tabId='ebook' />
                <Button
                  type='button'
                  onClick={handleAdvanceSearchChange}
                  className={cn('border mobile:col-span-2', {
                    'bg-secondary dark:bg-purple text-white dark:text-white-2 dark:border-purple':
                      !advanceSearch,
                    'bg-white dark:bg-dark-7 text-sencondary dark:text-dark-10 dark:border-dark-10':
                      advanceSearch,
                  })}
                  icon={
                    <AdvanceIcon
                      className={cn({
                        'text-white dark:text-white-2': !advanceSearch,
                        'text-secondary dark:text-dark-10': advanceSearch,
                      })}
                    />
                  }
                >
                  <span className='text-[14px] font-medium'>
                    การค้นหาขั้นสูง
                  </span>
                </Button>
              </div>
              {advanceSearch && (
                <div className='w-full flex flex-col space-y-5'>
                  <div className='grid grid-cols-3 mobile:grid-cols-1 gap-[20px]'>
                    <MultiSelectField
                      name='bookType'
                      label='ลักษณะงานเขียน'
                      placeholder='ลักษณะงานเขียน'
                      options={bookType}
                    />
                    <MultiSelectField
                      name='categoryIds'
                      label='หมวดหมู่'
                      placeholder='หมวดหมู่'
                      options={categories}
                    />
                    <MultiSelectField
                      name='penNameId'
                      label='นามปากกา'
                      placeholder='นามปากกา'
                      options={penNameOptions}
                    />
                  </div>
                  <div className='w-full flex tablet-mobile:grid tablet-mobile:gap-y-5 desktop:items-end desktop:space-x-5'>
                    <SelectButtonField
                      name='timeRange'
                      options={timeRangeOption}
                      label='เลือกช่วงเวลา'
                      mode='line'
                      onChange={() => {
                        if (values.startAt) {
                          setFieldValue('startAt', undefined)
                        }
                        if (values.endAt) {
                          setFieldValue('endAt', undefined)
                        }
                      }}
                    />
                    <div className='flex mobile:grid mobile:gap-y-[20px] w-full desktop-tablet:space-x-[20px]'>
                      <DateField
                        className='w-full tablet:w-[48.5%] text-secondary-1'
                        name='startAt'
                        placeholder='ตั้งแต่วันที่'
                        label='ตั้งแต่วันที่'
                        onChange={() => {
                          if (values.timeRange) {
                            setFieldValue('timeRange', undefined)
                          }
                        }}
                        maxDate={values.endAt || new Date()}
                      />
                      <DateField
                        className='w-full tablet:w-[48.5%] text-secondary-1'
                        name='endAt'
                        placeholder='ถึงวันที่'
                        label='ถึงวันที่'
                        onChange={() => {
                          if (values.timeRange) {
                            setFieldValue('timeRange', undefined)
                          }
                        }}
                        minDate={values.startAt}
                        maxDate={new Date()}
                      />
                    </div>
                    <div className='flex-shrink-0 tablet-mobile:w-full flex items-end justify-end space-x-[5px]'>
                      <Button
                        type='button'
                        className='text-secondar dark:text-dark-10 underline'
                        onClick={() => {
                          const initValues: SearchSaleAnalyticsType = {
                            ebookId: undefined,
                            bookType: [],
                            categoryIds: [],
                            penNameId: [],
                            timeRange: TimeRangeEnum.MONTH,
                          }

                          resetForm({ values: initValues })
                          handleSubmit(initValues)
                        }}
                      >
                        <span className='text-[14px] font-medium'>ล้างค่า</span>
                      </Button>
                      <Button
                        type='submit'
                        className='bg-primary dark:bg-purple text-white dark:text-white-2 w-[120px]'
                        disabled={isSubmitting}
                      >
                        <span className='text-[14px] font-medium'>ค้นหา</span>
                      </Button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Form>
        )}
      </Formik>
    </>
  )
}
